import { Module } from "vuex";
import { RootState } from "../types";
import { AuthState } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  token: "",
  error: "",
} as AuthState;

export const auth: Module<AuthState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
